import React, { useRef } from "react";

export default (p) => {
    const {devis,changeParams,showValidate,focusError} = p.container
    const value = devis.params[p.field]
    const checked = value == 'O'
    const label = devis.getLabel( p.field )
    let message = devis.validateMessage(p.field)
    const ref = useRef()
    if ( message && !p.noCheck ) focusError(ref)
    if ( !showValidate ) message = undefined

    return <><div ref={ref} className={'front_form_row'+(message?' invalidbox':'')+(p.disabled?' disabled':'')}>
        <label className={checked?'checked':'unchecked  '}><input type="checkbox" disabled={p.disabled} checked={checked} onChange={ ()=>{
            changeParams({ [p.field] : checked?'N':'O' })
        } }/> {label}</label>
    </div>
    {message?<div className="invalid">{message}</div>:''}
    </>
}
